function sm_resetMsgWin(){
  var label=$("#chat-button").contents().find("button").attr("aria-label");
  if(label.indexOf("Close")>=0){
    $("#chat-button").css({"position":"","left":"","top":"",'z-index':""});
    $("#chat-window").css({"position":"","left":"","top":""});
  }
}
function sm_initAdvice(){
  //$(".sm-advice a").attr("href","https://wa.me/008613823647423");
  $(".sm-advice a").attr("href","javascript:void(0);").removeAttr("target");
  $(".sm-contact-us-desc a").attr("href","javascript:void(0);").removeAttr("target");
  var fnn=function(e){
    //is whatsapp link
	//var ev=e||window.event;
    //var obj=ev.target||ev.srcElement;
    //if($(obj).closest("div").find("a").length>0){
    //  return;
    //}
    
    var label=$("#chat-button").contents().find("button").attr("aria-label");
    var btn=$("#chat-button").contents().find("button");
    if(label.length<=0)return;
    if(label.indexOf("Close")<0){btn.click();}
    var width=$(window).width();

    if(width>1000){
      btn.off("click",sm_resetMsgWin).on("click",sm_resetMsgWin);
      var x=e.pageX; //获取当前鼠标相对img的X坐标
      var y=e.pageY; //获取当前鼠标相对img的Y坐标
      if(x+360>width)x=x-360;
      $("#chat-button").css({"position":"absolute","left":x,"top":y,'z-index':2147483647});
      $("#chat-window").css({"position":"absolute","left":x,"top":y});
    }
  }
  $(".sm-advice a").click(fnn);
  $(".sm-contact-us-desc a").click(fnn);
  $(".sm-advice input.btn").click(fnn);
}
var g_sm_tm_FindRecBlock=0;
function sm_initProdDtlRecJs(){
  if(g_sm_tm_FindRecBlock>0)window.clearTimeout(g_sm_tm_FindRecBlock);
  var prod=$("#product-recommendations");
  if(prod.length>0){
      var prodLen= prod.find(".slick-track").length;
      if(prodLen==0){
        g_sm_tm_FindRecBlock=window.setTimeout(sm_initProdDtlRecJs,1000);
      }
      else{
        sm_initAdvice();
      }
    }
}
var g_sm_tm_FindSearchBlock=0;
function sm_initSearchProd(){
  if(g_sm_tm_FindSearchBlock>0)window.clearTimeout(g_sm_tm_FindSearchBlock);
  var prod=jQuery('.loading-modal');
  if(prod.css("display")=="block"){
    g_sm_tm_FindSearchBlock=window.setTimeout(sm_initSearchProd,1000);
  }
  else{
      sm_initAdvice();
  }
}
function sm_initSearchPageEvent(){
  jQuery(window).scroll(function() {
    var e = jQuery('[data-section-type="collection-template"]');
    e.length || (e = jQuery("[data-search-page]"));
    if(e.length){
      var i = e.offset().top + e.outerHeight() - jQuery(window).height();
      if (jQuery(this).scrollTop() > i && jQuery(this).scrollTop() < i + 200) {
          var o = jQuery(".infinite-scrolling a");
          if (o.length && !o.hasClass("disabled")) {
            g_sm_tm_FindSearchBlock=window.setTimeout(sm_initSearchProd(),500);
          }
      }
    }
  });
}


function flashPriceBthClick(){

  function __addItemToCart(data) {
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data:$("#add-to-cart-form").serialize(),
        dataType: "json",
        beforeSend: function() {},
        success: function(t) {
          window.location.href="/cart";
        }.bind(this),
        error: function(e, i) {
         
          var errorMessage = response.responseJSON
            ? response.responseJSON.description
            : "There was an error while updating your cart. Please try again.";
      __showErr(errorMessage);
        }.bind(this)
      });
    }
  function __showErr(msg){
    $("#spaFlashPriceErr").html(msg);
  }

  $.getJSON('/cart.js').then(
    function(cart) {
      var prodID=$("#hdProductID").attr("value");
      var exist=false;
      for(var i=0;i<cart.items.length;i++){
        d=cart.items[i];
        if(d.product_id==prodID ){
          exist=true;
          break;
        }
      }

      if(exist){
        __showErr("Only 1 piece limited to each person. ");
      }
      else{
        __addItemToCart();
      }
    }.bind(this)
  );
}
function initFlashPriceLinkText(){
  var countSeq=1;
  var fn=function(){
    
    var txt=$(".messageTimesBasic__3DxUY__dc__autoketing").parent();
    if(txt.length>0){
      txt.append($("<a  href='/collections/flash-sale' style='color:red;display:block;text-align:center;font-size:16px' >CLICK TO BUY >></a>"));
    }
    else {
      if(countSeq<10)window.setTimeout(fn,1000);
    }
    countSeq++;
    window.clearTimeout(flashTimeout);
  }
  var flashTimeout=window.setTimeout(fn,1000);
  
}
function sm_initSMSearch(){
  $(".header-search__form").hide();
  $(".search-form").hide();
  $(".sm-search-top-wrapper").find(".input").on('keydown', function(ev) {
    if(ev.keyCode==13){
      ev.preventDefault();
      var e=ev||window.event;
      var obj=e.target||e.srcElement;
      var v=$(obj).val();
      if(v.indexOf("-product_type:oem")<0){
        $(obj).val(v +" and -product_type:oem");
      }
      $(obj).closest("form").submit();
    }
  });

  $(".sm-search-top-wrapper").find("form").on('submit', function(e) {
    var obj=$(".sm-search-top-wrapper").find(".input");
    var v=$(obj).val();
    if(v.indexOf("-product_type:oem")<0){
      $(obj).val(v +" and -product_type:oem");
    }
    
  });

}
function initRecommendProduts(){
  var fn=function(arrKey,idx,callback){
    var tag=arrKey[idx];
    jQuery.getJSON("/search/suggest.json", {
      "q": tag,
      "resources": {
        "type": "product",
        "limit": 4,
        "options": {
          "unavailable_products": "last",
          "fields": "tag"
        }
      }
    }).done(function(rsp) {
      var d=rsp.resources.results.products;
      if(callback)callback(arrKey,idx,d);
    });
  }
  var obj=$("[data-smrecommend]");
  if(obj.length<=0){
    return;
  }
  var objv=obj.attr("data-smrecommend");
  var arr=objv.split("$$");
  var html="",d;
  var arrKey=[],idx=0;
  for(var i=0;i<arr.length;i++){
    d=arr[i];
    if(d==""){continue;}
    var arrx=d.split("desc:=");
    html+="<ul>";
    html+="<li><span>"+arrx[1]+"</span></li>";
    html+="<li>{"+idx+"}</li>";
    html+="</ul>";
    arrKey[arrKey.length]=arrx[0];
    idx++;
  }
  idx=0;
  var callRsp=function(arrKey,idx,dd){
    var d=null,htmlx="";
    for(var i=0;i<dd.length;i++){
      d=dd[i];
      d.url=d.url.slice(0,d.url.indexOf("?"));
      d.image=d.image.slice(0,d.image.lastIndexOf("."))+"_180x"+d.image.slice(d.image.lastIndexOf("."));
      htmlx+="<a href=\""+d.url+"\" target=\"_blank\">"
      +"<img src=\""+d.image+"\" alt=\""+d.title+"\" />"
      +"<label>"+d.title+"</label>"
      +"</a>";
    }
    html=html.replace("{"+idx+"}",htmlx);
    if(arrKey.length-1>idx){
      idx++;
      fn(arrKey,idx,function(arrKey,idx,dd){
        callRsp(arrKey,idx,dd);
      });
    }
    else{
      var obj=$(".sm-prod-desc").find(".sm-mb-rec-right");
      obj.find("ul").remove();
      obj.append($(html));

      obj=$(".sm-prod-desc").find(".rec-right");
      obj.find("ul").remove();
      obj.append($(html));
    }
  }

  fn(arrKey,idx,function(arrKey,idx,dd){
    callRsp(arrKey,idx,dd);
  });
}
function smShowCollectionVideo(){
  var obj=$(".collection-header .collection-image").find("iframe");
  if(obj.length>0){
      var h=obj.height();
      if(h>200)h=200;
      obj.width("100%").height(h);
      obj.css({"border":"1px solid #f9f9f9","border-radius":"5px"});
  }
}
$(document).ready(function(){
  smShowCollectionVideo();
  initRecommendProduts();
  //initFlashPriceLinkText();
  //sm_initSMSearch();
  sm_initAdvice();
  sm_initProdDtlRecJs();
  sm_initSearchPageEvent();

  $("#sm-product-add-to-cart").click(function(){
    flashPriceBthClick();
  });
  
 
  $(".sm-input-search").on('keydown', function(evt) {
      var e=evt||window.event;
      if(e.keyCode == 13) {
        var obj=e.target||e.srcElement;
        e.preventDefault();
        $(obj).each(function(idx,el){
          var v=$(obj).val();
          if(v.indexOf("-product_type:oem")<0){
            $(obj).val(v +"* -product_type:oem");
          }
          $(obj).closest("form").submit();
        });
      }
  });
  $(".sm-search-bar").find(".icon-search").on('click', function(evt) {
      var e=evt||window.event;
      e.preventDefault();
      var btn=e.target||e.srcElement;
      var obj=$(btn).closest("form").find(".sm-input-search");
      var v=$(obj).val();
      if(v.indexOf("-product_type:oem")<0){
        $(obj).val(v +"* and -product_type:oem");
      }
      $(obj).closest("form").submit();
  });

});